import { useTranslation } from 'react-i18next';
import { SecretRevealDialog } from './secret-reveal-dialog';

interface SaltRevealDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The salt cleartext to reveal — sourced from the mutation response, never a GET. */
  saltCleartext: string;
  onConfirm: () => void;
}

/**
 * Salt-Reveal-Modal (Spec 497 Inc 2, D-Components / D-Reveal). A thin, entry-agnostic wrapper
 * over the generic {@link SecretRevealDialog} (Spec 505 D-Reveal-Reuse: one reveal mechanism)
 * that injects the Salt-specific `reveal.*` copy from the `payment-link` namespace. The cleartext
 * lives only in the caller's state and is never persisted or logged. Reused by the Inc-2b wizard.
 */
export function SaltRevealDialog({
  open,
  onOpenChange,
  saltCleartext,
  onConfirm,
}: SaltRevealDialogProps) {
  const { t } = useTranslation('payment-link');
  return (
    <SecretRevealDialog
      open={open}
      onOpenChange={onOpenChange}
      secret={saltCleartext}
      onConfirm={onConfirm}
      labels={{
        title: t('reveal.title'),
        warning: t('reveal.warning'),
        hint: t('reveal.hint'),
        copy: t('reveal.copy'),
        copied: t('reveal.copied'),
        confirm: t('reveal.confirm'),
      }}
    />
  );
}
